import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { ParsedUrlQuery } from "querystring";
import { IActiveOrder, ICart, ProductItem, Collection ,ProductVariant, Product_list_elem} from "../../components/contracts/types";
import { Queries } from "../../services/queries";
import ProductView from "../../components/ProductView";

import CatPath from "../../components/catpath";
import Head from 'next/head'

import {WEBSERVER} from "../../services/globals"
import Header2 from "../../components/header-2";

interface IParams extends ParsedUrlQuery {
  slug: string;
}


interface Props {
  product: ProductItem;
  categories: any;
  slug: string;
}

interface IProductFacet {
  [key: string]: Array<string>;
}

const ProductDetailsPage: NextPage<Props> = ({ product, categories, slug }) => {
  if (!product) {
    return null;
  }

  const meta_content = `${product.name ?? ""} ${product.description ?? ""}`.trim();
  const canonicalurl = `${WEBSERVER}/items/${slug}`;

  return (
    <div>
      <Head>
        <title>{product.name}</title>
        <meta name="description" content={meta_content}></meta>
        <link rel="canonical" href={canonicalurl} />
      </Head>

      <div className="container-fluid">
        <a href={WEBSERVER}>home</a>
        <Header2 collections={categories.collections}></Header2>
        <div className="breadcrums"><CatPath product={product}></CatPath></div>

        <h2>{product.name}</h2>
        <ProductView product={product}></ProductView>
      </div>
    </div>
  );
};

export default ProductDetailsPage;

export const getStaticPaths: GetStaticPaths = async () => {
  const queries = new Queries(null);
  const resp = await queries.getProductBySlugs();
  const paths = resp.data.products.items.map((product: any) => ({
    params: { slug: product.slug },
  }));
  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { slug } = context.params as IParams;
//  console.log("+++++++ " + context);
  const queries = new Queries(null);
  const response = await queries.getProductDetailBySlug(slug);
  const categories = await queries.getCategories(); 
  //console.log("+++++++------ " + JSON.stringify(categories));
  return {
    props: {
      slug: context.params?.slug,
      product: response.data.product,
      categories: categories
    },
  };
};
